export default __webpack_public_path__ + "40dab79c172b6526dcf5353166d3bf9a.svg";